






























import { Component, Mixins, Prop } from "vue-property-decorator";
import { PdfStyleDrawableMixin } from "../../../base/components/system/mixins";
import { PdfViewer } from "../../../base/components/system/viewers";
import FormatArchiveSelector from "./selectors/FormatArchiveSelector.vue";
import { HeaderPane, RightSidePane, MenuPane, NavigationPane } from "../../../base/components/panes";
import { EditableFormatSummary } from "../../domain/editableFormat";

@Component({
  components: {
    HeaderPane,
    PdfViewer,
    RightSidePane,
    MenuPane,
    FormatArchiveSelector,
    NavigationPane,
  }
})
export default class FormatView extends Mixins(PdfStyleDrawableMixin) {
  @Prop()
  formatId: number;

  @Prop()
  archiveId: number;

  @Prop({ default: false })
  shouldNotifyRegistered: boolean;

  @Prop({ default: false })
  isTemporary: boolean;

  selectedArchive: EditableFormatSummary = null;
  selectedFormat: EditableFormatSummary = null;

  mounted(): void {
    if (this.shouldNotifyRegistered) {
      const action = this.isTemporary ? "一時保存" : "登録";
      this.$successAsHTML(
        action + "完了",
        "<div>" + this.formatNameWording + "を" + action + "しました。</div>"
      );
    }
  }

  get selectedPreviewSource(): string {
    return (!this.selectedFormat || !this.selectedFormat.previewSource)
      ? ""
      : this.selectedFormat.previewSource.source;
  }

  get selectedArchiveId(): number {
    return this.selectedFormat
      ? this.selectedFormat.archiveId
      : null;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  previewDocument(): void {
    if (!this.selectedFormat) {
      return;
    }
    this.$openWindow(
      "/PreviewNewDocument",
      {
        formatId: this.selectedFormat.id.toString(),
        archiveId: this.selectedArchiveId ? this.selectedArchiveId.toString() : null,
      }
    );
  }

  editFormat(): void {
    if (!this.selectedFormat) {
      return;
    }
    const route = {
      path: "EditFormat",
      query: {
        formatId: this.selectedFormat.id.toString(),
      }
    };
    this.$router.replace(route);
  }
}
